import storage from "src/services/storage";
import { TOKEN } from "src/helpers/constant";
import router from "src/router";
import { Auth } from "aws-amplify";
import { PureAbility, AbilityBuilder } from "@casl/ability";
import { reloadWindow, setMenuByPlanFunction } from "src/helpers/functions";
import { logLogoutHistoryApi, clearApiCache } from "src/services/api";
import { store } from "../index";

const state = {
  userInfo: null,
};

const SESSION_KEYS = [
  TOKEN,
  "refresh_token",
];

const getters = {};

const mutations = {
  updateUser(state, item) {
    state.userInfo = item;
    // console.log("User Info Updated: ", state.userInfo);
    if (state.userInfo) {
      const { plan_functions: planFunctions } = state.userInfo;
      const { can, rules } = new AbilityBuilder(PureAbility);
      const { plan: plan } = state.userInfo;
      const { organization: organization } = state.userInfo;

      if (planFunctions) {
        planFunctions.forEach((planFunction) => {
          can(planFunction.code);
        });
      }

      if (plan) {
        for (var key in plan) {
          if (organization.is_internal) {
            can(key);
            continue;
          }
          if (
            plan[key] &&
            (plan[key] == "available" || plan[key] == "unlimited")
          ) {
            can(key);
          }

          if (
            plan[key] &&
            (plan[key]["value"] == "available" ||
              plan[key]["value"] == "non_initial_link" ||
              plan[key]["value"] == "initial_link" ||
              plan[key]["value"] == "unlimited")
          ) {
            can(key);
          }
        }
        // console.log("All new rules: ", rules);
        this._vm.$ability.update(rules);
      }
    }
    setMenuByPlanFunction();
  },
};

const actions = {
  async login(context, term) {
    storage.set(TOKEN, term);
  },
  async logout(context) {
    if (storage.get(TOKEN)) {
      store.commit("app/setLoading", [await logLogoutHistoryApi()]);
    }
    clearApiCache();
    SESSION_KEYS.forEach((key) => storage.remove(key));
    const currentRouteName = router.currentRoute && router.currentRoute.name;
    if (currentRouteName !== "Login") {
      router.push({ name: "Login" }).catch((err) => {
        if (err && err.name !== "NavigationDuplicated") {
          console.error(err);
        }
      });
    }
    Auth.signOut();
    await context.commit("updateUser", null);
    setTimeout(() => {
      reloadWindow();
    }, 1000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
